import { CommonModule } from '@angular/common';
import { Component, Input } from '@angular/core';

import { CardValue } from '../../../models/communication/cards.enum';

@Component({
    selector: 'app-card',
    imports: [CommonModule],
    templateUrl: './card.component.html',
    styleUrl: './card.component.scss'
})
export class CardComponent {
    @Input()
    cardValue?: CardValue;

    @Input()
    rotated = false;

    @Input()
    compact = false;
}
